import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UBXGridModule } from '../grid/grid.module';
import { UBXIconModule } from '../icon/icon.module';
import { UBXTabsComponent } from './tabs.component';
import { UBXTabsTabComponent } from './tab/tabs-tab.component';

const Imports = [
    UBXGridModule,
    UBXIconModule,
];
const Module = [
    UBXTabsComponent,
    UBXTabsTabComponent
];

@NgModule({
    declarations: [
        Module
    ],
    imports: [
        CommonModule,
        Imports
    ],
    exports: [
        Module
    ],
})
export class UBXTabsModule {}
